"use strict";
exports.__esModule = true;
var angular = require("angular");
var PdfViewerComponent = /** @class */ (function () {
    function PdfViewerComponent($rootScope, $scope, $timeout) {
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        ctrl.guideCommand = '';
        $scope.$on('command:PDF_VIEWER', function (event, args) {
            ctrl.guideCommand = 'PDF_VIEWER';
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initPDFViewer(event, args);
        });
        $timeout();
        $('select option')
            .filter(function () {
            return !this.value || $.trim(this.value).length == 0 || $.trim(this.text).length == 0;
        })
            .remove();
    }
    PdfViewerComponent.prototype.initPDFViewer = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.urlGot = args.config.data.url;
        ctrl.$scope.$apply();
    };
    return PdfViewerComponent;
}());
angular.module('smartorg.r6.acts.pdfViewer', []).component('pdfViewer', {
    template: require('./pdf-viewer.component.html'),
    controller: PdfViewerComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
}).filter('trusted', ['$sce', function ($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }]);
module.exports = 'smartorg.r6.acts.pdfViewer';
//# sourceMappingURL=pdf-viewer.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/pdf-viewer/pdf-viewer.component.js